"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericPlugin = void 0;
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
class GenericPlugin {
    constructor(options) {
        this.options = options;
        this.install = function install(vm, options) { };
        this.store = {};
        const constructor = this.constructor;
        if (constructor.instance) {
            return constructor.instance;
        }
        constructor.instance = this;
    }
    static getInstance() {
        return this.instance;
    }
    static install(vm, options) {
        if (this.installed)
            return;
        this.installed = true;
        this.beforeInstall(vm, options);
        const constructor = this;
        let mixinInstalled = false;
        const plugin = new constructor(options);
        if (vm !== vue_1.default && !window._VueInstanceGuard && process.env.NODE_ENV !== 'production') {
            console.warn('Warning: It seems like you have multiple Vue instances: your main Vue constructor does NOT match'
                + ' the one used in a plugin. Please make sure you are using vm.use() and NOT Vue.use(). This is also'
                + ' applies to registering components, directives, and mixins.');
            window._VueInstanceGuard = true;
        }
        plugin.registerComponents(vm);
        vm.mixin({
            beforeCreate() {
                if (mixinInstalled)
                    return;
                mixinInstalled = true;
                plugin.bindVm(this, vm);
            },
        });
    }
    registerStore() {
        vue_1.default.nextTick(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const store = this.vmInstance.$store;
            if (!store.hasModule(this.pluginName)) {
                store.registerModule(this.pluginName, this.store);
                yield store.dispatch('moduleRegistered', this.pluginName, { root: true });
            }
        }));
    }
    registerComponents(vm) {
        Object.keys(this.components || {}).forEach(componentName => {
            if (!this.components)
                return;
            vm.component(componentName, this.components[componentName]);
        });
    }
    runHooks(vm) {
        vm.mixin(this.componentCreated(this.vmInstance));
        this.pluginInstalled(vm, this.vmInstance);
    }
    registerAccessor(vm) {
        const { pluginName } = this;
        if (!pluginName) {
            throw new Error('Plugin name is not defined. Please existence of "pluginName" property in your plugin');
        }
        Object.assign(vm.prototype, {
            [`${pluginName}`]: this,
        });
    }
    bindVm(instance, vm) {
        this.vmInstance = instance;
        this.registerStore();
        this.runHooks(vm);
        this.registerAccessor(vm);
        return this;
    }
    componentCreated(vm) {
        return {};
    }
    pluginInstalled(vm, instance) {
    }
    static beforeInstall(vm, options) {
    }
}
exports.GenericPlugin = GenericPlugin;
//# sourceMappingURL=generic.plugin.js.map